
import React, { useEffect } from 'react';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import Guide from './pages/Guide';
import AccountType from './pages/Guide/pages/AccountType';
import Welcome from './pages/Guide/pages/Welcome';
import Info from './pages/Info';
import NotFound from './pages/NotFound';
import Happens from 'pages/Happens';
import NotificationPage from 'pages/NotificationPage';
import Timeout from 'pages/Timeout';
import Technicals from 'pages/Technicals';
import IndustryView from 'pages/IndustryView';
import ProviderTime from 'components/ProviderTime';
import Maintenance from 'pages/Maintenance';
import { getUrlParams } from "./utils/url";
import { retrieveMockData } from '__mock__/mock';
import { fetchMaintenanceApiStatus } from 'utils/maintenance';

const location = globalThis.location;
/* NOSONAR */
if (process.env.MOCK === 'on'){
  if (getUrlParams('dummy', location.search || location.hash.replace('#/','')) === 'on') {
    sessionStorage.setItem('dummy', 'on');
    retrieveMockData();
  }
}

const App = () => {
  const acTypeStr = 'ac' + 'countType';
  const queryAcType = sessionStorage.getItem('AC_TYPE') || getUrlParams(acTypeStr, location.search || location.hash.replace('#/','')) || 'ONE';
  if (queryAcType) {
      sessionStorage.setItem('AC_TYPE', queryAcType);
  }

  useEffect(() => {
    let active = true;
    const preloadPromise = fetchMaintenanceApiStatus()
      .then((data) => {
        if (active) {
          globalThis.maintenanceContext = data;
        }
        return data;
      })
      .catch((error) => {
        console.log('[maintenance] preload failed', error);
        if (active) {
          delete globalThis.maintenanceContext;
        }
        return null;
      });

    globalThis.maintenanceContextPromise = preloadPromise;

    return () => {
      active = false;
    };
  }, []);

  return (
    <Router basename={process.env.publicPath}>
      <ProviderTime>
        <Switch>
          <Route exact path="/" component={Guide} />
          <Route path="/AccountType" component={AccountType} />
          <Route path="/Welcome" component={Welcome} />
          <Route path="/info" component={Info} />
          <Route path="/industryView" component={IndustryView} />
          <Route path="/happens" component={Happens} />
          <Route path="/error" component={NotificationPage} />
          <Route path="/timeout" component={Timeout} />
          <Route path="/tax-validation-technicals" render={() => <Technicals showTryAgain={false} />} />
          <Route path="/technicals" component={Technicals} />
          <Route path="/maintenance" component={Maintenance} />
          <Route component={NotFound} />
        </Switch>
      </ProviderTime>
    </Router>
  );
}

export default App;
